import resetState from '@/helpers/resetState';
import { ABI } from './ABI';
import { Contract } from 'web3-eth-contract';
import store from '@/store';

const FEATURE_NAME = 'OraclizeFeature';
const ONE_WEY = 1000000000000000000;

let from;

async function contract(): Promise<Contract> {
  from = {from: store.getters.getWallet};
  const address = store.getters.getFeatureAddress(FEATURE_NAME);
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, address);
    resolve(contract);
  });
}

const initialState = {
  oneUSDtoETH: null,
  oneETHtoUSD: null
};

const state = {
  oneUSDtoETH: initialState.oneUSDtoETH,
  oneETHtoUSD: initialState.oneETHtoUSD
};

const getters = {
  getOneETHtoUSD: state => state.oneETHtoUSD
};

const mutations = {
  setOneUSDtoETH: (state, item) => {
    state.oneUSDtoETH = item;
  },
  setOneETHtoUSD: (state, item) => {
    state.oneETHtoUSD = item;
  },
  resetOraclizeFeature: state => {
    resetState(state, initialState);
  }
};

const actions = {
  initOraclizeFeature({ dispatch }) {
    // dispatch('oneUSDtoETHDapp'); XDAi don't use oneUSDtoETHDapp
  },
  /**
   * Get the price for one dollar on the ethereum
   * @res "price" {string}
   */
  oneUSDtoETHDapp ({ commit }, obj) {
    contract().then(contract => {
      contract.methods.oneUSDtoETH()
        .call()
        .then(res => {
          commit('setOneUSDtoETH', res);
          commit('setOneETHtoUSD', ONE_WEY / res);
        })
        .catch(err => {
          console.error('oneUSDtoETH Error:', err.message);
        });
    });
  },
  /**
   * Get count of deal
   * @param amount {number}
   * @param price {string}
   * @return {Promise<number>}
   * @res "count of deal" {string}
   */
  countDealDapp(_, { amount, price }) {
    return new Promise((resolve, reject) => {
      contract().then(contract => {
        contract.methods.countDeal(amount, price)
          .call()
          .then(res => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    });
  },
  /**
   * Get count of fees
   * @param address {string}
   * @param amount {number}
   * @return {Promise<number>}
   * @res "count of fees" {string}
   */
  countFeesDapp({ getters }, amount) {
    return new Promise((resolve, reject) => {
      contract().then(contract => {
        contract.methods.countFees(getters.getWallet, amount)
          .call()
          .then(res => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
